module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-TW":{"title":"AI 推薦關鍵字說明","description_title":"請嘗試針對推薦關鍵字撰寫評論。","description_content":"無需煩惱撰寫內容，嘗試根據推薦關鍵字撰寫評論吧。AI將分析文本以判斷是否包含關鍵字內容。","disclaimer":"*AI分析可能存在誤差，並可能影響實際發放的回饋金額。"}}')
  delete Component.options._Ctor
}
